var React = require('react');

function Referrals (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.297 8.328v15.375h15.375V8.328H17.297zm-1.922-3.844h19.219c1.061 0 1.922.86 1.922 1.922v19.219c0 1.061-.86 1.922-1.922 1.922H15.375a1.922 1.922 0 0 1-1.922-1.922V6.406c0-1.061.86-1.922 1.922-1.922zm7.688 26.266h2.562v5.125c0 .708-.574 1.281-1.281 1.281H5.125a1.281 1.281 0 0 1-1.281-1.281V16.656c0-.707.573-1.281 1.281-1.281h5.125v2.563H6.406v16.656h16.657V30.75z","transform":"translate(-3 -4)"}));
}

Referrals.defaultProps = {"viewBox":"0 0 34 34"};

module.exports = Referrals;

Referrals.default = Referrals;
